import apiActionsMagazineInfo from '@/api/actions-magazine'

const state = {
  error: null,
  isLoading: false,
  data: null,
}

export const mutationTypes = {
  getActionsMagazineInfoStart:
    '[actions-magazine info] Get actions-magazine start',
  getActionsMagazineInfoSuccess:
    '[actions-magazine info] Get actions-magazine success',
  getActionsMagazineInfoFailure:
    '[actions-magazine info] Get actions-magazine failure',
}

export const actionTypes = {
  getActionsMagazineInfo: '[update actions-magazine info] Get actions-magazine',
}

const mutations = {
  [mutationTypes.getActionsMagazineInfoStart](state) {
    state.data = null
    state.isLoading = true
  },

  [mutationTypes.getActionsMagazineInfoSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getActionsMagazineInfoFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getActionsMagazineInfo](context, {id}) {
    context.commit(mutationTypes.getActionsMagazineInfoStart)
    return new Promise((resolve) => {
      apiActionsMagazineInfo
        .getActionsMagazine(id)
        .then((response) => {
          context.commit(
            mutationTypes.getActionsMagazineInfoSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getActionsMagazineInfoFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
